import React from "react";
import { useTranslation } from "react-i18next";

const PrimaryButton = ({ onClick, loading, text, loadingText }) => {
  const { t } = useTranslation();
  const baseClasses = [
    "w-full px-6 py-3 rounded-full",
    "flex items-center justify-center gap-2 group",
    "transition-all duration-300 ease-in-out",
    "border border-slate-700/80",
    "whitespace-nowrap",
    "relative z-10",
  ];

  const conditionalClasses = loading
    ? [ 
        "bg-lime-400 text-black cursor-not-allowed", 
      ]
    : [ 
        "bg-lime-300 text-black hover:bg-lime-400",
        "active:translate-y-0 active:shadow-[0_1px_0_0_rgba(15,23,42,0.9)]",
      ];

  return (
    <button
      onClick={onClick}
      disabled={loading}
      className={[...baseClasses, ...conditionalClasses].join(" ")} 
    >
      {loading ? (
        <>
          <svg className="animate-spin -ml-1 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span>{loadingText || t("primary_button.loading_fallback")}</span>
        </>
      ) : (
        <span>{text}</span>
      )}
    </button>
  );
};

export default PrimaryButton;
